import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Graph from './Graph'
import bemClass from './../../../utils/bemClass'
import { randomInt } from './../../../utils/random'

const cn = bemClass('Bullets')

class Item extends PureComponent {
    handleClick = e => {
        e.stopPropagation()
        const { onClick, id } = this.props
        onClick(id)
    }
    render() {
        const { active } = this.props
        const position = randomInt(0, 8) * 10
        const style = { transform: `translate3d(${position}%, 0, 0)` }
 
        return (
            <div className={cn('item')} onClick={this.handleClick}>
                <Graph className={cn('bullet', { active })} style={style} />
            </div>
        )
    }
}

Item.propTypes = {
    active: PropTypes.bool,
    id: PropTypes.number,
    onClick: PropTypes.func,
}

Item.defaultProps = {
    onClick: () => {},
    active: false,
}

export default Item


// WEBPACK FOOTER //
// ./src/components/Slider/Bullets/Item.jsx